import React from 'react';
import './index.scss';
import TextInput from 'components/atoms/Input/TextInput';
import PcErrorArea from 'components/molecules/PcErrorArea';

const PcInputHourSalary = ({
  // 表示
  hourSalaryMin,
  // input
  value,
  onChange,
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  // エラー
  inValid,
  errMessage,
  apiErrMessage
}) => {
  return (
    <div className="PcInputHourSalary">
      <div className="PcInputHourSalary-wrapper">
        <div className='title-area'>
          <div className='title'>
            請求金額目安（1時間当たり）
          </div>
          <div className='notice'>
            ※交通費は別途ご請求となります
          </div>
        </div>
        <div className='input-hour-salary'>
          <span className='item'>{hourSalaryMin}</span>
          <span className='item hourSalary-label'>円</span>
          <span className='item hourSalary-label'>～</span>
          <span className='item'>
            <TextInput
              val={value}
              onChange={onChange}
              onInput={onInput}
              onCompositionEnd={onCompositionEnd}
              maxLength={maxLength}
              placeholder={placeholder}
              inValid={inValid}
            />
            <span className='item hourSalary-label'>円</span>
            <PcErrorArea position='' message={errMessage} />
          </span>
        </div>
      </div>
      <div className="api-err">
        <PcErrorArea position='' message={apiErrMessage} />
      </div>
    </div>
  );
};

export default PcInputHourSalary;